

//  React base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import tableDesign from "assets/theme/components/table/tableDesign";

const { white } = colors;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      boxShadow: "none",
      border: tableDesign.containerBorder,
      borderRadius: borderRadius.xl,
    },
  },
};

export default tableContainer;
